import { useEffect, useRef } from 'react';

type Callback = (...args: any[]) => void;
export const usePooling = (
  shouldPool: boolean,
  callback: Callback,
  delay: number,
) => {
  const savedCallback = useRef<Callback>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    let id: NodeJS.Timeout;

    const handler = (...args: any[]) => savedCallback.current(...args);

    if (shouldPool) {
      id = setInterval(handler, delay);
    } else {
      if (id) {
        clearInterval(id);
      }
    }

    return () => {
      if (id) {
        clearInterval(id);
      }
    };
  }, [shouldPool, delay]);
};
